import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { useSignInMfaOtp } from "@/hooks/use-auth-client/use-sign-in-mfa-otp";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";
import { InputTextFieldNew } from "@/components/ui/form/fields-new/input-field/input-text";

import { useLoadingScreen } from "../../side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";
import { AuthForm } from "../_components/auth-form";
import { authVerifyMfaOtpInputZodSchema } from "./_schema/validation-schema";

import type { AuthVerifyMfaOtpInputType } from "./_schema/validation-schema";

export const AuthVerifyMfaOtp = () => {
	const form = useForm<AuthVerifyMfaOtpInputType>({
		mode: "onChange",
		resolver: zodResolver(authVerifyMfaOtpInputZodSchema),
		defaultValues: {
			code: "",
		},
	});

	const {
		register,
		formState: { errors },
	} = form;

	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { signInMfaOtp } = useSignInMfaOtp();

	const handleButtonClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		const data = form.getValues();
		showLoadingScreenCallback();

		await signInMfaOtp(data.code).finally(() => {
			hideLoadingScreenCallback();
		});
	};

	return (
		<AuthForm
			handlePrimaryButtonClick={handleButtonClick}
			disabled={!form.formState.isValid}
			formTitle="2段階認証"
			primaryButtonText="サインイン"
			otherInfo={
				<div className="grid justify-end text-right">
					<a href={PATHS.AUTH.SIGN_UP}>
						<Button variant={"link"}>アカウントをお持ちでない場合</Button>
					</a>
				</div>
			}
		>
			<InputTextFieldNew
				label="認証コード"
				errorMessage={errors.code?.message}
				autoComplete="one-time-code"
				type="text"
				inputMode="numeric"
				placeholder="XXXXXX"
				{...register("code")}
			/>
		</AuthForm>
	);
};
